import { BadgeCheckIcon, ChipIcon } from "@heroicons/react/solid";
import React from "react";
import { skills } from "../data";
import { ratings } from "../data";

export default function Skills() {
  return (
    <section id="skills">
      <div className="container px-5 py-10 mx-auto">
        <div className="text-center mb-20">
          <ChipIcon className="w-10 inline-block mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4">
            Skills &amp; Technologies
          </h1>
          <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
            Whilst creating projects I've used a range of technologies, frameworks and programming languages.
            The list here shows the skills I most frequently use and have been developing the most. Aside from the skills listed below
            I also have experience in, C, Docker and Dart/Flutter.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
  {skills.map((skill, index) => (
    <div key={skill} className="p-2 w-full">
      <div className="bg-gray-900 rounded flex p-4 h-full items-center" style={{ height: '80px' }}>
        <span className="title-font font-medium text-white flex items-center w-full">
          <span className="inline-block w-28">{skill}</span>
          <div className="flex items-center space-x-1">
            {[...Array(5)].map((_, i) => (
              <BadgeCheckIcon
                key={i}
                className={`text-green-400 w-6 h-6 flex-shrink-0 ${i < ratings[index] ? '' : 'opacity-0'}`}
              />
            ))}
          </div>
        </span>
      </div>
    </div>
  ))}
</div>

      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Skills.js